import { queryOptions } from '@tanstack/react-query';
import { fileStatusCountsQueryFunction } from '@/modules/Dashboard/queries/fileStatusCounts/fileStatusCountsQueryFunction.ts';

export const fileStatusCountsQueryOptions = queryOptions({
  queryFn: fileStatusCountsQueryFunction,
  queryKey: ['file-status-counts'],
});
